import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { useForm, Controller } from 'react-hook-form'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'

export default function EncryptedFieldChallengeModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const { handleSubmit, control, reset, register } = useForm();
  const request = useRequest()
  const customerId = modal.options?.customerId
  const fieldName = modal.options?.fieldName
  const title = modal.options?.title
  const [saving, setSaving] = useState(false)

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
    reset()
  };

  const onSubmit = async (formData) => {
    setSaving(true)
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer/${customerId}/verify_encrypted_field`)
    try {
      const response = await request.post(formData)
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        dispatch(setNotification({ type: 'success', body: response?.data?.message }))
      } else {
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }

  // eslint-disable-next-line no-nested-ternary
  return modal.is_active && modal.type === 'encrypted_field_challenge_modal' ? (
    <form onSubmit={handleSubmit(onSubmit)} id="encrypted_field_challenge_modal_form">
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card column is-3">
          <header className="modal-card-head py-3">
            <p className="modal-card-title is-capitalized">
              {title}
            </p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section
            className="modal-card-body modal-card-body pt-4 pb-2"
            style={{ minHeight: "50px", overflow: 'hidden' }}
          >
            <div className="columns mb-0 is-flex-direction-column">
              <div className="column">
                <div className="mt-1">
                  <Controller
                    name={`value`}
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <input {...field} type="text" className="input is-small" placeholder="Please enter value to validate" />
                    )}
                  />
                  <input type="hidden" name="field_name" value={`${fieldName}_encrypted`} {...register('field_name')} />
                </div>
              </div>
            </div>
          </section>
          <footer className="modal-card-foot is-justify-content-end py-1">
            <div className="lox-form__buttons-wrapper has-text-right">
              <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
              <button type="submit" className="button is-link is-small" disabled={saving && 'disabled'}>{saving ? 'Verifying' : 'Verify'}</button>
            </div>
          </footer>
        </div>
      </div>
    </form>
  ) : null;
}
